import QStepApi from '@/libraries/Api/QStep/Api'
import store from '@/store'
import router from '@/router'
import Maintenance from '@/libraries/Util/Maintenance'

export default class Authentication {
  login (credentials) {
    const qStepApi = new QStepApi()

    return qStepApi.authenticate(credentials)
      .then(function (response) {
        store.commit('login', response.data)
        router.push('/applications')
      }).catch(function (error) {
        return Promise.reject(error.response)
      })
  }

  clientCredentialsLogin () {
    const qStepApi = new QStepApi()

    return qStepApi.clientCredentialsAuthenticate()
      .then(function (response) {
        store.commit('clientCredentialsLogin', response.data)
      }).catch(function (error) {
        return Promise.reject(error.response)
      })
  }

  logout (errorMessages = []) {
    store.commit('logout')

    if (errorMessages.length === 0) {
      Maintenance.update()
    } else {
      router.push({ name: 'Login', params: { errorMessages: errorMessages } })
    }
  }

  isUnauthorized (error) {
    return error.response.status === 401
  }

  unauthorized () {
    this.logout(['Unauthorized access, please login again'])
  }
}
